import {DeleteOutlined} from '@mui/icons-material'
import {IconButton, IconButtonProps} from '@mui/material'
import React from 'react'

/**
 * Componend intended to be used as a delete button in settings
 * when saving onBlur is enabled,  it prioritizes onClick event
 * @param IconButtonProps
 */

export const DeleteButton = ({...props}: IconButtonProps) => {
  return (
    <IconButton
      color="error"
      // postponing onBlur event, so it happens after onClick
      onMouseDown={(e) => e.preventDefault()}
      {...props}
    >
      <DeleteOutlined />
    </IconButton>
  )
}
